/**
 * Auth methods
 */
export const PASSWORD = 'password';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';
